import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { EventHandlerSummaryList } from "./eventHandlerSummaryList";
import { IEventHandler } from "source/models/event/eventHandler";
import { FormRow } from "../framework/formRow";

//EventEditEventHandlersSummary
interface IEventEditEventHandlersSummaryProp {
    userCode: string;
    eventHandlers: IEventHandler[];
    comment: string;
    isClosed: boolean;
    approveDate: number;
    publishDate: number;
    createDate: number;
    onApproveEventHandler: () => void;
}

export class EventEditEventHandlersSummary extends React.Component<IEventEditEventHandlersSummaryProp, {}> {
    render() {
        const props = this.props;
        let processingTime: number = null;
        let processingTimeHours: number = 0;
        let processingTimeDays: number = 0;
        if (props.isClosed) {
            processingTime = props.approveDate - (!Base.isNullOrUndefined(props.publishDate) ? props.publishDate : props.createDate);
            if (!Base.isNullOrUndefined(processingTime)) {
                processingTimeHours = processingTime / (60 * 60 * 1000);
                processingTimeDays = Math.floor(processingTimeHours / 24);
                processingTimeHours = processingTimeHours % 24;
            }
        }
        return (
            <div className="summarySection">
                <div className="row">
                    <div className="col-12">
                        <EventHandlerSummaryList
                            userCode={props.userCode}
                            eventHandlers={props.eventHandlers}
                            onApproveClick={props.onApproveEventHandler} />
                    </div>
                </div>
                {!Base.isNullOrUndefined(processingTime) &&
                    <FormRow
                        label={Translations.ProcessingTime}
                    >
                        <div>{(processingTimeDays > 0.5 ? processingTimeDays.toLocaleFixed(0) + " " + Translations.Days + " " : "") + processingTimeHours.toLocaleFixed(0) + " " + Translations.Hours}</div>
                    </FormRow>
                }
                {!Base.isNullOrEmpty(props.comment) &&
                    <FormRow
                        label={Translations.Comment}
                    >
                        <div className="preWrap">{props.comment}</div>
                    </FormRow>
                }
            </div>
        );
    }
}
